import { defineAsyncComponent } from '../compat/vueCompat';
import type { NleProject } from '@mimir/primitive/nle/project';
import { requestDialog } from './requestDialog';
import type { SavePremiereProjectDialogRequest } from './savePremiereProjectDialogRequest';

const SavePremiereProjectDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/SavePremiereProjectDialog.vue'));

export function showSavePremiereProjectDialog(
  project: NleProject,
  targetFolderId: string | undefined,
) {
  const req: SavePremiereProjectDialogRequest = {
    project,
    targetFolderId,
  };
  requestDialog(req, SavePremiereProjectDialog);
}
